import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/t/requested-details')({
  staticData: { hideShell: true, breadcrumb: 'Required Details', breadcrumbKey: 'K_BREADCRUMB_REQUIRED_DETAILS' },
});
